import { Empty } from 'antd';
import React from 'react';

function CustomEmptyDescription() {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      styles={{ margin: '20px' }}
      description={
        <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>データがありません</span>
      }
    />
  );
}

export default CustomEmptyDescription;
